import { useSystemMessages } from '../context/SystemMessagesContext';

export const useSystemMessage = (messageName: string, defaultValue: string = '') => {
  const { systemMessages } = useSystemMessages();
  return systemMessages.find(config => config.Name === messageName)?.Value || defaultValue;
};
